var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"svg-royaume",class:{
      'active':_vm.r && _vm.r.isActive
    }},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.click}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }